// ## context provider on the top level of PIM to manage the required data of the PIM
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { capitalize, isArray } from 'lodash';
import * as action from '../../store/DAM.action';
import { getDamProductRecordById } from '../../../DevlopmentOrder/Dam/DamFiles/store/DamFile.action';

export const StateContext = createContext(null);

export default function DAMAddEditModuleStateProvider({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const dragDropFiles = location?.state?.choosedFolderFiles || false;
  const isFolderDragDrop = location?.state?.isFolderDragDrop || false;
  const reducerState = useSelector((redState) => redState);
  const {
    damModule: { damEditData },
  } = reducerState;
  const { damId, devOrderId } = useParams();

  const initialSetting = {
    loader: false,
    dam: [
      {
        assetType: null,
        assetTitle: '',
        assignedTo: [],
        size: '',
        fileType: '',
        colourTheme: null,
        primaryColour: null,
        secondaryColour: null,
        folder: [],
        description: '',
        tags: [],
        croppedImage: '',
        imageUrl: '',
        dimension: '',
        dynamicDropdown: [],
        dynamicText: [],
        duration: 0,
        videoThumbnail: '',
        videoUrl: '',
        videoLink: '',
        imageLink: '',
        videoLinkType: null,
      },
    ],
  };

  const [DamAddeditstate, setAddEditDAMState] = useState(initialSetting);

  useEffect(() => {
    const callFn = async () => {
      setAddEditDAMState((prev) => ({
        ...prev,
        loader: true,
      }));
      if (devOrderId) {
        await dispatch(getDamProductRecordById(damId, devOrderId));
      } else {
        await dispatch(action.getDamRecordById(damId));
      }
      setAddEditDAMState((prev) => ({
        ...prev,
        loader: false,
      }));
    };
    if (damId) {
      callFn();
    }
  }, [damId, dispatch, devOrderId]);

  useEffect(() => {
    if (isArray(dragDropFiles) && dragDropFiles?.length && isFolderDragDrop) {
      const multipleChoosedFiles = dragDropFiles.map((item) => {
        const assetValue = item.fileType.includes('image') ? { value: 'image', label: 'Image' } : { value: 'video', label: 'Video' };
        const isImageType = item.fileType.includes('image');
        return {
          assetType: assetValue,
          assetTitle: '',
          assignedTo: [],
          size: item?.size || '',
          fileType: item?.fileType || '',
          colourTheme: null,
          primaryColour: null,
          secondaryColour: null,
          folder: [],
          description: '',
          tags: [],
          croppedImage: isImageType ? item.base64Url || '' : '',
          imageUrl: isImageType ? item.base64Url || '' : '',
          dimension: isImageType ? item?.dimensions || '' : '',
          dynamicDropdown: [],
          dynamicText: [],
          duration: isImageType ? 0 : item?.duration || 0,
          videoThumbnail: isImageType ? '' : item.thumbnail,
          videoUrl: isImageType ? '' : item.base64Url || '',
          videoLink: '',
          imageLink: '',
          fileName: item?.fileName || '',
          videoLinkType: null,
        };
      });
      setAddEditDAMState((prev) => ({ ...prev, dam: multipleChoosedFiles }));
    }
  }, [isFolderDragDrop, dragDropFiles?.length]);

  useEffect(() => {
    if (damEditData && damId) {
      const cloneDam = { ...damEditData };
      cloneDam.assetType = { label: capitalize(cloneDam.assetType), value: cloneDam.assetType };
      cloneDam.folder = cloneDam?.folders?.map((item) => {
        return { ...item, label: item.name, value: item._id };
      });
      cloneDam.assignedTo = cloneDam?.assignedTo?.map((item) => {
        return { ...item, label: item.number, value: item._id };
      });
      cloneDam.dynamicDropdown = cloneDam?.dynamicDropdown?.map((item) => {
        return {
          lableId: item?.lableId?._id,
          optionId: item?.optionId?._id,
        };
      });
      cloneDam.dynamicText = cloneDam?.dynamicText?.map((item) => {
        return {
          lableId: item?.lableId?._id,
          valueText: item?.valueText,
        };
      });
      cloneDam.videoLinkType = {
        label: capitalize(cloneDam.videoLinkType),
        value: cloneDam.videoLinkType,
      };
      setAddEditDAMState((prev) => ({ ...prev, dam: [cloneDam] }));
    }
  }, [damEditData, damId, devOrderId]);

  useEffect(() => {
    return () => {
      dispatch(action.clearDamReducer());
      setAddEditDAMState(initialSetting);
    };
  }, [dispatch]);

  const contextValue = useMemo(() => {
    return { DamAddeditstate, setAddEditDAMState };
  }, [setAddEditDAMState, DamAddeditstate]);

  return <StateContext.Provider value={contextValue}>{children}</StateContext.Provider>;
}

export function useDAMAddEditModuleState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the DAM add edit Module State Provider');
  }
  return context;
}
